import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7827892a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-5" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-th",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_6 = { class: "lista_atendimentos card p-0" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<li class=\"header_list d-flex col-12 p-5\" data-v-7827892a><span class=\"col-1 d-flex subtitulo\" data-v-7827892a>Id ticket</span><span class=\"col-3 d-flex subtitulo\" data-v-7827892a>Resumo</span><span class=\"col-1 d-flex subtitulo\" data-v-7827892a>Status</span><span class=\"col-2 d-flex subtitulo\" data-v-7827892a>Loja (PDV)</span><span class=\"col-2 d-flex subtitulo\" data-v-7827892a>Categoria</span><span class=\"col-1 d-flex subtitulo\" data-v-7827892a>Suporte</span><span class=\"col-1 d-flex subtitulo\" data-v-7827892a>Data</span><span class=\"col-1 d-flex justify-content-center subtitulo\" data-v-7827892a>Ações</span></li>", 1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "col-1 d-flex justify-content-start" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "col-3 d-flex justify-content-start" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "col-1 d-flex justify-content-start" }
const _hoisted_14 = {
  style: {"white-space":"nowrap"},
  class: "texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_15 = { class: "col-2 d-flex justify-content-start ps-2" }
const _hoisted_16 = {
  style: {"white-space":"nowrap"},
  class: "texto bold cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_17 = { class: "col-2 d-flex justify-content-start" }
const _hoisted_18 = {
  style: {"white-space":"nowrap"},
  class: "texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_19 = { class: "col-1 d-flex justify-content-start ps-2" }
const _hoisted_20 = {
  key: 0,
  style: {"white-space":"nowrap"},
  class: "texto bold cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_21 = {
  key: 1,
  style: {"white-space":"nowrap"},
  class: "texto bold cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_22 = {
  class: "col-1 d-flex justify-content-start ps-2",
  style: {"min-width":"110px"}
}
const _hoisted_23 = {
  style: {"white-space":"nowrap"},
  class: "texto bold cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_24 = { class: "col-1 d-flex justify-content-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px"},
  class: "m-0 fas fa-pencil-alt"
}, null, -1))
const _hoisted_26 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center p-8 w-100 h-100"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto cor_texto_1" }, "Nenhum ticket encontrado ...", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 2,
  class: "d-flex justify-content-center align-items-center p-8 w-100 h-100"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto cor_texto_1" }, "Buscando tickets...", -1))
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Reportes")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        ((_ctx.user?.nivelCargo && +_ctx.user.nivelCargo <= 100) || (Array.isArray(_ctx.projecList) && _ctx.projecList.length))
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              text: "Projetos",
              style: {"min-width":"fit-content"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('projects')))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          variant: "secondary",
          text: "Reportar novo",
          style: {"min-width":"fit-content"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('tickets')))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_6, [
      _hoisted_7,
      (_ctx.arrayTickets.length > 0 && !_ctx.storeLoader.status)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.arrayTickets, (ticket, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              onClick: ($event: any) => (_ctx.router.push({ name: 'ticketsId', params: { id: `${ ticket.id }` } })),
              style: {"height":"fit-content","border-radius":"10px","cursor":"pointer"},
              class: "usuario card d-flex flex-row p-5 align-items-center"
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", {
                  style: {"white-space":"nowrap"},
                  class: "texto bold cor_texto_1 d-inline-block text-truncate",
                  title: ticket?.id
                }, _toDisplayString(ticket?.id || "-"), 9, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", {
                  style: {"white-space":"nowrap"},
                  class: "texto bold cor_texto_1 d-inline-block text-truncate",
                  title: ticket?.title
                }, _toDisplayString(ticket?.title || "-"), 9, _hoisted_12)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, [
                  (_ctx.idProject === 5)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        style: _normalizeStyle({ 'color': _ctx.statusColor( _ctx.verificarStatus(ticket.ticket_json)) })
                      }, _toDisplayString(_ctx.verificarStatus(ticket.ticket_json)), 5))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        style: _normalizeStyle({ 'color': _ctx.statusColor(ticket.status) })
                      }, _toDisplayString(ticket?.status || "-"), 5))
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(ticket?.store_name || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(ticket?.category || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                (ticket?.support)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(ticket.support.split(' ').length > 2 ? `${ticket.support.split(' ')[0]} ${ticket.support.split(' ')[1]}` : ticket.support), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_21, " Indicar gestão "))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.moment(ticket?.created_at).format('DD/MM/YYYY') || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Button, {
                  variant: "secondary",
                  onClick: ($event: any) => (_ctx.router.push({ name: 'ticketsId', params: { id: `${ ticket.id }` } }))
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ], 8, _hoisted_8))
          }), 128))
        : (!_ctx.storeLoader.status && _ctx.arrayTickets.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
          : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
    ]),
    (_openBlock(), _createBlock(_component_Pagination, {
      key: _ctx.route.path,
      ref: "ticketsPaginationRef",
      arr: _ctx.arrayTickets,
      totalBanco: _ctx.totalItems,
      onPageChanged: _ctx.handlePageChange,
      tipo: 'tickets'
    }, null, 8, ["arr", "totalBanco", "onPageChanged"]))
  ]))
}